<template lang="pug">
  .bg-gray-100.p-2.min-h-screen
    h3.font-bold.mb-3.text-gray-700.text-center 
      span(v-if="!_id") Nueva 
      span(v-if="copiando") Copiando 
      span Cirugía
      div(v-if="_id")
        span.text-xxs.block.text-gray-600.font-bold.text-left.mb-0.pl-1 Creado {{ fechaCreacion | fromNow }}
      div(v-if="copiando")
        span.text-xxs.block.text-gray-600.font-bold.text-left.mb-0.pl-1 Copiando cirugía, haga los cambios necesarios y presione guardar


    transition-group.contenedor-transition-box(name="fade-smooth-two", tag="div")

      .flex.mb-2(key="fecha")
        .flex-1
          span.block.text-gray-600.font-bold.text-left.mb-0.pl-1 Fecha
          
          input.w-full.bg-gray-200.appearance-none.outline-none.border-2.border-gray-300.rounded.py-2.pl-2.px-4.text-gray-700.leading-tight.placeholder-gray-400.font-bold.text-sm(
            type="date"
            v-model='fecha'
          )

      .flex.mb-2(key="hora")
        .flex-1
          span.block.text-gray-600.font-bold.text-left.mb-0.pl-1 Hora
          
          input.w-full.bg-gray-200.appearance-none.outline-none.border-2.border-gray-300.rounded.py-2.pl-2.px-4.text-gray-700.leading-tight.placeholder-gray-400.font-bold.text-sm(
            type="time"
            v-model='hora'
          )

      .flex.mb-2(key="doctor")
        .flex-1
          span.block.text-gray-600.font-bold.text-left.mb-0.pl-1 Doctor
          .relative
            input.w-full.bg-gray-200.appearance-none.outline-none.border-2.border-gray-300.rounded.pr-10.py-2.pl-10.px-4.text-gray-700.leading-tight.placeholder-gray-400.font-bold.text-sm(
              v-model='nombreDoctor'
              @keyup.down="showPopoverDoctor = true"
              @keyup.up="showPopoverDoctor = true"
              @keyup.space="showPopoverDoctor = true"
              @click="showPopoverDoctor = true"
              ref="doctor"
              placeholder="No se han ingresado datos"
            )
            span.absolute.left-0.top-0.pt-2.pl-3
              i.fas.fa-user-md.text-gray-500
            
            span.absolute.right-0.top-0.pt-2.pr-3(@click="showPopoverDoctor = true")
              i.fas.fa-angle-down.text-gray-500
            transition(name="slide-up")
              u-popover(v-if="showPopoverDoctor", @close="showPopoverDoctor = false")
                doctor-seleccionar(
                  @selected="seleccionarDoctor"
                  @close="cerrarDoctor"
                )

      .flex.mb-2(key="clinica")
        .flex-1
          span.block.text-gray-600.font-bold.text-left.mb-0.pl-1 Clínica
          .relative
            input.w-full.bg-gray-200.appearance-none.outline-none.border-2.border-gray-300.rounded.pr-10.py-2.pl-10.px-4.text-gray-700.leading-tight.placeholder-gray-400.font-bold.text-sm(
              v-model='descripcionClinica'
              @keyup.down="showPopoverClinica = true"
              @keyup.up="showPopoverClinica = true"
              @keyup.space="showPopoverClinica = true"
              @click="showPopoverClinica = true"
              ref="clinica"
              placeholder="No se han ingresado datos"
            )
            span.absolute.left-0.top-0.pt-2.pl-3
              i.fas.fa-hospital.text-gray-500
            
            span.absolute.right-0.top-0.pt-2.pr-3(@click="showPopoverClinica = true")
              i.fas.fa-angle-down.text-gray-500
            transition(name="slide-up")
              u-popover(v-if="showPopoverClinica", @close="showPopoverClinica = false")
                clinica-seleccionar(
                  @selected="seleccionarClinica"
                  @close="cerrarClinica"
                )

      .flex.mb-2(key="tipo-cirugia")
        .flex-1
          span.block.text-gray-600.font-bold.text-left.mb-0.pl-1 Tipo cirugía
          .relative
            input.w-full.bg-gray-200.appearance-none.outline-none.border-2.border-gray-300.rounded.pr-10.py-2.pl-10.px-4.text-gray-700.leading-tight.placeholder-gray-400.font-bold.text-sm(
              v-model='descripcionTipoCirugia'
              @keyup.down="showPopoverTipoCirugia = true"
              @keyup.up="showPopoverTipoCirugia = true"
              @keyup.space="showPopoverTipoCirugia = true"
              @click="showPopoverTipoCirugia = true"
              ref="tipoCirugia"
              placeholder="No se han ingresado datos"
            )
            span.absolute.left-0.top-0.pt-2.pl-3
              i.fas.fa-procedures.text-gray-500
            
            span.absolute.right-0.top-0.pt-2.pr-3(@click="showPopoverTipoCirugia = true")
              i.fas.fa-angle-down.text-gray-500
            transition(name="slide-up")
              u-popover(v-if="showPopoverTipoCirugia", @close="showPopoverTipoCirugia = false")
                tipo-cirugia-seleccionar(
                  @selected="seleccionarTipoCirugia"
                  @close="cerrarTipoCirugia"
                )


      .flex.mb-2(key="tecnico")
        .flex-1
          span.block.text-gray-600.font-bold.text-left.mb-0.pl-1 Técnico
          .relative
            input.w-full.bg-gray-200.appearance-none.outline-none.border-2.border-gray-300.rounded.pr-10.py-2.pl-10.px-4.text-gray-700.leading-tight.placeholder-gray-400.font-bold.text-sm(
              v-model='nombreTecnico'
              @keyup.down="showPopoverTecnico = true"
              @keyup.up="showPopoverTecnico = true"
              @keyup.space="showPopoverTecnico = true"
              @click="showPopoverTecnico = true"
              ref="tecnico"
              placeholder="No se han ingresado datos"
              :disabled="perfil === 'tecnico'"
            )
            span.absolute.left-0.top-0.pt-2.pl-3
              i.fas.fa-user-cog.text-gray-500
            
            span.absolute.right-0.top-0.pt-2.pr-3(@click="showPopoverTecnico = true", v-if="perfil !== 'tecnico'")
              i.fas.fa-angle-down.text-gray-500
            transition(name="slide-up")
              u-popover(v-if="showPopoverTecnico", @close="showPopoverTecnico = false")
                tecnico-seleccionar(
                  @selected="seleccionarTecnico"
                  @close="cerrarTecnico"
                )

      .flex.mb-2(key="enfermera")
        .flex-1
          span.block.text-gray-600.font-bold.text-left.mb-0.pl-1 Enfermera
          .relative
            input.w-full.bg-gray-200.appearance-none.outline-none.border-2.border-gray-300.rounded.pr-10.py-2.pl-10.px-4.text-gray-700.leading-tight.placeholder-gray-400.font-bold.text-sm(
              v-model='nombreEnfermera'
              @keyup.down="showPopoverEnfermera = true"
              @keyup.up="showPopoverEnfermera = true"
              @keyup.space="showPopoverEnfermera = true"
              @click="showPopoverEnfermera = true"
              ref="enfermera"
              placeholder="No se han ingresado datos"
              :disabled="perfil === 'enfermera'"
            )
            span.absolute.left-0.top-0.pt-2.pl-3
              i.fas.fa-user-nurse.text-gray-500
            
            span.absolute.right-0.top-0.pt-2.pr-3(@click="showPopoverEnfermera = true", v-if="perfil !== 'enfermera'")
              i.fas.fa-angle-down.text-gray-500
            transition(name="slide-up")
              u-popover(v-if="showPopoverEnfermera", @close="showPopoverEnfermera = false")
                enfermera-seleccionar(
                  @selected="seleccionarEnfermera"
                  @close="cerrarEnfermera"
                )

      .flex.mb-2(key="tipo-cobro")
        .flex-1
          span.block.text-gray-600.font-bold.text-left.mb-0.pl-1 Tipo cobro
          
          .flex.w-full
            .flex.flex-col.flex-1.justify-center.items-center.m-1.bg-gray-200.appearance-none.outline-none.border-2.border-gray-300.rounded.py-2.px-4.text-gray-700.leading-tight.placeholder-gray-400.font-bold.text-sm.transition.duration-300.ease-in-out.cursor-pointer(
              @click="tipoCobro = tipoCobro === 'particular' ? '' : 'particular'"
              :class="{'is-active': tipoCobro === 'particular'}"
            )

              i.fas.fa-money-bill.text-gray-500
              span Particular
            .flex.flex-col.flex-1.justify-center.items-center.m-1.bg-gray-200.appearance-none.outline-none.border-2.border-gray-300.rounded.py-2.px-4.text-gray-700.leading-tight.placeholder-gray-400.font-bold.text-sm.transition.duration-300.ease-in-out.cursor-pointer(
              @click="tipoCobro = tipoCobro === 'credito' ? '' : 'credito'"
              :class="{'is-active': tipoCobro === 'credito'}"
            )
              i.fas.fa-money-check.text-gray-500
              span Crédito
            .flex.flex-col.flex-1.justify-center.items-center.m-1.bg-gray-200.appearance-none.outline-none.border-2.border-gray-300.rounded.py-2.px-4.text-gray-700.leading-tight.placeholder-gray-400.font-bold.text-sm.transition.duration-300.ease-in-out.cursor-pointer(
              @click="tipoCobro = tipoCobro === 'transferencia' ? '' : 'transferencia'"
              :class="{'is-active': tipoCobro === 'transferencia'}"
            )
              i.fas.fa-hand-holding-usd.text-gray-500
              span Transferencia

      
      .flex.mb-2(v-if="tipoCobro === 'particular'", key="monto-cobrado")
        .flex-1
          span.block.text-gray-600.font-bold.text-left.mb-0.pl-1 ¿Cuánto ha cobrado?
          
          input.w-full.bg-gray-200.appearance-none.outline-none.border-2.border-gray-300.rounded.pr-10.py-2.pl-2.px-4.text-gray-700.leading-tight.placeholder-gray-400.font-bold.text-sm(
            type="number"
            v-model='montoCobrado'
          )

      .flex.mb-2(v-if="tipoCobro === 'credito'", key="nombre-paciente")
        .flex-1
          span.block.text-gray-600.font-bold.text-left.mb-0.pl-1 Nombre del paciente
          
          input.w-full.bg-gray-200.appearance-none.outline-none.border-2.border-gray-300.rounded.pr-10.py-2.pl-2.px-4.text-gray-700.leading-tight.placeholder-gray-400.font-bold.text-sm(
            type="text"
            v-model='nombrePaciente'
          )

      .flex.mb-2(key="clipsUtilizados")
        .flex-1
          span.block.text-gray-600.font-bold.text-left.mb-0.pl-1 Clips utilizados
          
          input.w-full.bg-gray-200.appearance-none.outline-none.border-2.border-gray-300.rounded.pr-10.py-2.pl-2.px-4.text-gray-700.leading-tight.placeholder-gray-400.font-bold.text-sm(
            type="number"
            v-model='clipsUtilizados'
          )

      .flex.mb-2(key="numeroCaja")
        .flex-1
          span.block.text-gray-600.font-bold.text-left.mb-0.pl-1 Número de caja
          
          input.w-full.bg-gray-200.appearance-none.outline-none.border-2.border-gray-300.rounded.pr-10.py-2.pl-2.px-4.text-gray-700.leading-tight.placeholder-gray-400.font-bold.text-sm(
            type="number"
            v-model='numeroCaja'
          )

      .p-2(key="grapas-container")
        .border-solid.border-2.border-slate-300.p-2
          span.block.text-gray-600.font-bold.text-left.mb-0.pl-1 Grapas utilizadas

          transition-group.contenedor-transition-box(name="fade-smooth-two", tag="div")
            .flex.w-full.flex-wrap(key="g-1")
              .flex.flex-col.flex-1.justify-center.items-center.m-1.bg-gray-200.appearance-none.outline-none.border-2.border-gray-300.rounded.py-2.px-4.text-gray-700.leading-tight.placeholder-gray-400.font-bold.text-sm.transition.duration-300.ease-in-out.cursor-pointer.text-center(
                v-for="o in listaMarcasGrapa"
                @click="seleccionarMarca(o)"
                :class="{'is-active': codigoMarcaGrapa === o.codigo}"
              )
                span {{ o.descripcion }}

            .p-2(key="g-2", v-if="codigoMarcaGrapa !== '' && codigoMarcaGrapa !== 'doctorUtilizoSusGrapas'")
              span.block.text-gray-600.font-bold.text-left.mb-0.text-xs.pb-1 Ingresa el numero de grapas utilizadas por color
              .flex.w-full.p-2.items-center
                .bg-purple-500.rounded-full.w-8.h-8
                input.w-full.bg-gray-200.appearance-none.outline-none.border-2.border-gray-300.rounded.pr-10.py-2.pl-2.px-4.text-gray-700.leading-tight.placeholder-gray-400.font-bold.text-sm.ml-2(
                  type="number"
                  v-model='grapasMoradas'
                )

              .flex.w-full.p-2.items-center
                .bg-black.rounded-full.w-8.h-8
                input.w-full.bg-gray-200.appearance-none.outline-none.border-2.border-gray-300.rounded.pr-10.py-2.pl-2.px-4.text-gray-700.leading-tight.placeholder-gray-400.font-bold.text-sm.ml-2.cursor-not-allowed(
                  type="number"
                  v-model='grapasNegras'
                )

              .flex.w-full.p-2.items-center
                .bg-yellow-500.rounded-full.w-8.h-8
                input.w-full.bg-gray-200.appearance-none.outline-none.border-2.border-gray-300.rounded.pr-10.py-2.pl-2.px-4.text-gray-700.leading-tight.placeholder-gray-400.font-bold.text-sm.ml-2(
                  type="number"
                  v-model='grapasDoradas'
                )


      .flex.mb-2(key="comentario")
        .flex-1
          span.block.text-gray-600.font-bold.text-left.mb-0.pl-1 Comentario
          
          textarea.w-full.bg-gray-200.appearance-none.outline-none.border-2.border-gray-300.rounded.pr-10.py-2.pl-2.px-4.text-gray-700.leading-tight.placeholder-gray-400.font-bold.text-sm(
            v-model='comentario'
          )
      
      div.mb-3(v-if="copiando", key="copy-message")
        span.text-xxs.block.text-gray-600.font-bold.text-left.mb-0.pl-1 Copiando cirugía, haga los cambios necesarios y presione guardar
      
      .flex.mb-2.justify-center.mb-20(key="acciones")
        .bg-primary.text-sm.flex.items-center.text-white.py-2.px-4.rounded.cursor-pointer(@click="save") Guardar
        .text-primary.text-sm.flex.items-center.border-primary.border.py-2.px-4.rounded.ml-2.cursor-pointer(@click="irANuevaCirugia", v-if="_id") Nueva cirugía
        .bg-primary.text-sm.flex.items-center.text-white.py-2.px-4.rounded.ml-2.cursor-pointer(v-if="_id && copiando === false", @click="copy") Duplicar
        .bg-red-500.text-sm.flex.items-center.text-white.py-2.px-4.rounded.ml-2.cursor-pointer(v-if="perfil === 'administrador' && _id && !copiando", @click="remove") Eliminar


</template>

<script>
import Popover from '@/components/c_util_popover.vue'
import ClinicaSeleccionar from '@/components/c_clinica_seleccionar.vue'
import DoctorSeleccionar from '@/components/c_doctor_seleccionar.vue'
import TecnicoSeleccionar from '@/components/c_tecnico_seleccionar.vue'
import EnfermeraSeleccionar from '@/components/c_enfermera_seleccionar.vue'
import TipoCirugiaSeleccionar from '@/components/c_tipo_cirugia_seleccionar.vue'
import { apiGet, apiPost, apiDelete, notify } from '../util/general'
import Router from '../router/admin.js'
export default {
  name: 'v_cirugia_form',
  props: ['_id'],
  components: {
    'u-popover'                : Popover,
    'clinica-seleccionar'      : ClinicaSeleccionar,
    'doctor-seleccionar'       : DoctorSeleccionar,
    'tecnico-seleccionar'      : TecnicoSeleccionar,
    'enfermera-seleccionar'    : EnfermeraSeleccionar,
    'tipo-cirugia-seleccionar' : TipoCirugiaSeleccionar
  },
  data () {
    return {
      perfil                 : localStorage.getItem('perfil'),
      nombreUsuarioLogueado  : localStorage.getItem('nombre'),
      idLogueado             : localStorage.getItem('_id'),
      isLoading              : false,
      // input clinica
      showPopoverClinica     : false,
      idClinica              : '',
      descripcionClinica     : '',
      // input doctor
      showPopoverDoctor      : false,
      idDoctor               : '',
      nombreDoctor           : '',
      // input tecnico
      showPopoverTecnico     : false,
      idTecnico              : '',
      nombreTecnico          : '',
      // input enfermera
      showPopoverEnfermera   : false,
      idEnfermera            : '',
      nombreEnfermera        : '',
      // input tipo cirugia
      showPopoverTipoCirugia : false,
      idTipoCirugia          : '',
      descripcionTipoCirugia : '',
      //
      comentario             : '',
      tipoCobro              : '',
      montoCobrado           : 0,
      fecha                  : '',
      hora                   : '',
      nombrePaciente         : '',
      clipsUtilizados        : 0,
      grapasUtilizadas       : 0,
      fechaCreacion          : '',
      copiando               : false,
      // grapas
      listaMarcasGrapa: [
        {
          codigo: 'covidien',
          descripcion: 'Covidien'
        },
        {
          codigo: 'miconvey',
          descripcion: 'Miconvey'
        },
        {
          codigo: 'doctorUtilizoSusGrapas',
          descripcion: 'Doctor utilizó sus grapas'
        },
        {
          codigo: '',
          descripcion: 'No se utilizaron grapas'
        }
      ],
      codigoMarcaGrapa      : '',
      descripcionMarcaGrapa : 'No se utilizaron grapas',
      grapasMoradas         : 0,
      grapasNegras          : 0,
      grapasDoradas         : 0,
      numeroCaja            : 0
    }
  },
  mounted () {
    var vm = this
    if (vm._id) {
      // Si tiene un id, debemos cargar esa cirugia
      vm.fetch()
    } else {
      vm.fecha = window.moment().format('YYYY-MM-DD')
      vm.hora = window.moment().format('HH:mm')
      if (vm.perfil === 'tecnico') {
        vm.idTecnico     = vm.idLogueado
        vm.nombreTecnico = vm.nombreUsuarioLogueado
      }

      if (vm.perfil === 'enfermera') {
        vm.idEnfermera     = vm.idLogueado
        vm.nombreEnfermera = vm.nombreUsuarioLogueado
      }
    }
  },
  methods: {
    // Popover clinica
    seleccionarClinica (o) {
      var vm            = this
      vm.idClinica      = o._id + ''
      vm.descripcionClinica = o.descripcion
      vm.showPopoverClinica = false
      vm.$refs.clinica.focus()
    },
    cerrarClinica (o) {
      var vm            = this
      vm.showPopoverClinica = false
      vm.$refs.clinica.focus()
    },
    //* Popover clinica
    // Popover Doctor
    seleccionarDoctor (o) {
      var vm            = this
      vm.idDoctor           = o._id + ''
      vm.nombreDoctor       = o.nombre
      // Setear clinica default
      vm.idClinica          = o.idClinica
      vm.descripcionClinica = o.descripcionClinica
      vm.showPopoverDoctor  = false
      vm.$refs.doctor.focus()
    },
    cerrarDoctor (o) {
      var vm            = this
      vm.showPopoverDoctor = false
      vm.$refs.doctor.focus()
    },
    //* Popover Doctor
    // Popover Tecnico
    seleccionarTecnico (o) {
      var vm            = this
      vm.idTecnico           = o._id + ''
      vm.nombreTecnico       = o.nombre
      vm.showPopoverTecnico  = false
      vm.$refs.tecnico.focus()
    },
    cerrarTecnico (o) {
      var vm            = this
      vm.showPopoverTecnico = false
      vm.$refs.tecnico.focus()
    },
    //* Popover Tecnico
    // Popover Enfermera
    seleccionarEnfermera (o) {
      var vm            = this
      vm.idEnfermera           = o._id + ''
      vm.nombreEnfermera       = o.nombre
      vm.showPopoverEnfermera  = false
      vm.$refs.enfermera.focus()
    },
    cerrarEnfermera (o) {
      var vm            = this
      vm.showPopoverEnfermera = false
      vm.$refs.enfermera.focus()
    },
    //* Popover Enfermera
    // Popover Tipo Cirugia
    seleccionarTipoCirugia (o) {
      var vm            = this
      vm.idTipoCirugia           = o._id + ''
      vm.descripcionTipoCirugia       = o.descripcion
      vm.showPopoverTipoCirugia  = false
      vm.$refs.tipoCirugia.focus()
    },
    cerrarTipoCirugia (o) {
      var vm            = this
      vm.showPopoverTipoCirugia = false
      vm.$refs.tipoCirugia.focus()
    },
    //* Popover TipoCirugia
    seleccionarMarca (o) {
      var vm = this
      vm.codigoMarcaGrapa      = o.codigo
      vm.descripcionMarcaGrapa = o.descripcion
    },
    save () {
      var vm = this
      if (!vm.idDoctor) {
        notify(vm, 'error', 'Error', 'Debe ingresar un doctor')
        return
      }
      if (!vm.idClinica) {
        notify(vm, 'error', 'Error', 'Debe ingresar una clínica')
        return
      }
      if (!vm.idTipoCirugia) {
        notify(vm, 'error', 'Error', 'Debe ingresar un tipo de cirugía')
        return
      }

      if (vm.copiando) vm._id = ''

      if (vm.codigoMarcaGrapa !== '' && vm.codigoMarcaGrapa !== 'doctorUtilizoSusGrapas') {
        if (!vm.grapasMoradas && !vm.grapasNegras && !vm.grapasDoradas) {
          notify(vm, 'error', 'Error', 'Debe ingresar la cantidad de grapas utilizadas')
          return
        }
      } else {
        vm.grapasMoradas  = 0
        vm.grapasNegras   = 0
        vm.grapasDoradas  = 0
      }

      vm.grapasUtilizadas = +vm.grapasMoradas + +vm.grapasNegras + +vm.grapasDoradas

      // vm.isLoading = true
      var obj = {
        _id                    : vm._id,
        fecha                  : vm.fecha,
        hora                   : vm.hora,
        idDoctor               : vm.idDoctor,
        nombreDoctor           : vm.nombreDoctor,
        idClinica              : vm.idClinica,
        descripcionClinica     : vm.descripcionClinica,
        idTipoCirugia          : vm.idTipoCirugia,
        descripcionTipoCirugia : vm.descripcionTipoCirugia,
        idTecnico              : vm.idTecnico,
        nombreTecnico          : vm.nombreTecnico,
        idEnfermera            : vm.idEnfermera,
        nombreEnfermera        : vm.nombreEnfermera,
        comentario             : vm.comentario,
        tipoCobro              : vm.tipoCobro,
        clipsUtilizados        : vm.clipsUtilizados,
        grapasUtilizadas       : vm.grapasUtilizadas,
        codigoMarcaGrapa       : vm.codigoMarcaGrapa,
        descripcionMarcaGrapa  : vm.descripcionMarcaGrapa,
        grapasMoradas          : vm.grapasMoradas,
        grapasNegras           : vm.grapasNegras,
        grapasDoradas          : vm.grapasDoradas,
        numeroCaja             : vm.numeroCaja
      }

      if (vm.tipoCobro === 'particular') {
        obj.montoCobrado = vm.montoCobrado
      }

      if (vm.tipoCobro === 'credito') {
        obj.nombrePaciente = vm.nombrePaciente
      }

      apiPost(vm, '/cirugia', obj, function (data) {
        notify(vm, 'success', 'Éxito', 'Guardado correctamente')

        var _id = vm._id
        if (!vm._id) _id = data.insertedId

        Router.push('/cirugia/' + _id)
        vm.$router.go()
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      })
    },
    fetch () {
      var vm = this
      vm.isLoading  = true
      var url       = '/cirugia/' + vm._id
      var obj = {
        _id : vm._id
      }
      apiGet(vm, url, obj, function (data) {
        vm.fecha                  = data.documento.fecha
        vm.hora                   = data.documento.hora
        vm.idDoctor               = data.documento.idDoctor
        vm.nombreDoctor           = data.documento.nombreDoctor
        vm.idClinica              = data.documento.idClinica
        vm.descripcionClinica     = data.documento.descripcionClinica
        vm.idTipoCirugia          = data.documento.idTipoCirugia
        vm.descripcionTipoCirugia = data.documento.descripcionTipoCirugia
        vm.idTecnico              = data.documento.idTecnico
        vm.nombreTecnico          = data.documento.nombreTecnico
        vm.idEnfermera            = data.documento.idEnfermera
        vm.nombreEnfermera        = data.documento.nombreEnfermera
        vm.comentario             = data.documento.comentario
        vm.tipoCobro              = data.documento.tipoCobro
        vm.montoCobrado           = data.documento.montoCobrado
        vm.nombrePaciente         = data.documento.nombrePaciente
        vm.clipsUtilizados        = data.documento.clipsUtilizados
        vm.grapasUtilizadas       = data.documento.grapasUtilizadas
        vm.codigoMarcaGrapa       = data.documento.codigoMarcaGrapa || ''
        vm.descripcionMarcaGrapa  = data.documento.descripcionMarcaGrapa || 'No se utilizaron grapas'
        vm.grapasMoradas          = data.documento.grapasMoradas || 0
        vm.grapasNegras           = data.documento.grapasNegras || 0
        vm.grapasDoradas          = data.documento.grapasDoradas || 0
        vm.numeroCaja             = data.documento.numeroCaja || 0

        vm.fechaCreacion          = data.documento.fechaCreacion
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
        Router.push('/cirugia')
      }, function () {
        vm.isLoading  = false
      })
    },
    irANuevaCirugia () {
      var vm = this
      Router.push('/cirugia')
      vm.$router.go()
    },
    copy () {
      var vm = this
      vm.copiando = true
    },
    remove () {
      var vm = this

      var confirmed = window.confirm('¿Desea eliminar esta cirugia?')

      if (confirmed) {
        var obj = {
          _id                    : vm._id
        }
        apiDelete(vm, '/cirugia', obj, function (data) {
          notify(vm, 'success', 'Éxito', 'Eliminado correctamente')
          Router.push('/cirugias/')
          vm.$router.go()
        }, function (error) {
          notify(vm, 'error', 'Error', error.message)
        })
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
  .is-active
    color #2e7bda
    i
      color #2e7bda
    border-color #2e7bda
    
</style>



// WEBPACK FOOTER //
// v_cirugia_form.vue?f0708e0c